// Schema (AJV) do fluxo — compatível com:
// - send_text com "conditional" (primeiro contato, dias, datas) e preview (opcional)
// - send_buttons (até 10) com quickReplyTemplate e clique (goto/set_mode/end)
// - send_list com clique (goto/set_mode/end)
// - platform_lookup com mensagens por caso (status_pedido, link_transporte, nota_fiscal)
// - validate_customer (novo)
// - set_mode com assign_agent_id (opcional) e assign_random_agent_ids (novo)
// - set_tags para atribuir tags a conversa
export default {
  $id: 'https://manyconvert.com/schemas/botFlow.json',
  type: 'object',
  required: ['start', 'states'],
  additionalProperties: false,
  properties: {
    settings: {
      type: 'object',
      additionalProperties: false,
      properties: {
        autoclose_minutes: { type: 'integer', minimum: 0 }, // 0 = desabilitado
      },
    },
    start: { type: 'string', minLength: 1 },
    states: {
      type: 'object',
      additionalProperties: {
        type: 'object',
        additionalProperties: false,
        properties: {
          on_enter: { $ref: '#/$defs/actions' },
          on_message: {
            type: 'array',
            items: {
              type: 'object',
              additionalProperties: false,
              properties: {
                if: {
                  type: 'object',
                  additionalProperties: false,
                  properties: {
                    interactive_reply_id: { type: ['string', 'number'] },
                    text_includes: { type: 'array', items: { type: 'string' } },
                  },
                },
                then: { $ref: '#/$defs/actions' },
              },
              required: ['then'],
            },
          },
        },
        required: ['on_enter', 'on_message'],
      },
    },
  },

  $defs: {
    /* ====== Util: arrays somente de send_text ====== */
    sendTextArray: {
      type: 'array',
      items: {
        type: 'object',
        additionalProperties: false,
        properties: {
          action: { const: 'send_text' },
          text: { type: 'string' },
          preview: { type: 'boolean' },
          conditional: {
            type: 'object',
            additionalProperties: false,
            properties: {
              first_contact: {
                type: 'object',
                additionalProperties: false,
                properties: {
                  first_time: { type: 'string' },
                  returning: { type: 'string' },
                },
                required: ['first_time'],
              },
              days_of_week: {
                type: 'array',
                items: { type: 'integer', minimum: 0, maximum: 6 },
                uniqueItems: true,
              },
              days_of_weekProxy: {
                type: 'object',
                additionalProperties: { type: 'boolean' },
              },
              dates: {
                type: 'array',
                items: { type: 'string', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
                uniqueItems: true,
              },
            },
          },
        },
        required: ['action', 'text'],
      },
    },

    /* ====== Ações ====== */
    actions: {
      type: 'array',
      items: { $ref: '#/$defs/action' },
    },

    action: {
      type: 'object',
      oneOf: [
        /* -------- send_text -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'send_text' },
            text: { type: 'string' },
            preview: { type: 'boolean' },
            conditional: {
              type: 'object',
              additionalProperties: false,
              properties: {
                first_contact: {
                  type: 'object',
                  additionalProperties: false,
                  properties: {
                    first_time: { type: 'string' },
                    returning: { type: 'string' },
                  },
                  required: ['first_time'],
                },
                days_of_week: {
                  type: 'array',
                  items: { type: 'integer', minimum: 0, maximum: 6 },
                  uniqueItems: true,
                },
                days_of_weekProxy: {
                  type: 'object',
                  additionalProperties: { type: 'boolean' },
                },
                dates: {
                  type: 'array',
                  items: { type: 'string', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
                  uniqueItems: true,
                },
              },
            },
          },
          required: ['action', 'text'],
        },

        /* -------- send_buttons -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'send_buttons' },
            header: { type: 'string' },
            body: { type: 'string' },
            footer: { type: 'string' },
            buttons: {
              type: 'array',
              maxItems: 10,
              items: {
                type: 'object',
                additionalProperties: false,
                properties: {
                  id: { type: 'string' },
                  title: { type: 'string' },
                  // extras do editor para auto-regra/preview
                  click_action: { enum: ['goto', 'set_mode', 'end'] },
                  goto_state: { type: 'string' },
                },
                required: ['id', 'title'],
              },
            },
            quickReplyTemplate: {
              type: 'object',
              additionalProperties: false,
              properties: {
                name: { type: 'string' },
                language: { type: 'string' },
                params: {
                  type: 'object',
                  additionalProperties: false,
                  properties: {
                    header: { type: 'array' },
                    body: { type: 'array' },
                    footer: { type: 'array' },
                  },
                },
              },
            },
          },
          required: ['action'],
        },

        /* -------- send_list -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'send_list' },
            header: { type: 'string' },
            body: { type: 'string' },
            footer: { type: 'string' },
            button_text: { type: 'string' },
            sections: {
              type: 'array',
              minItems: 1,
              items: {
                type: 'object',
                additionalProperties: false,
                properties: {
                  title: { type: 'string' },
                  rows: {
                    type: 'array',
                    minItems: 1,
                    items: {
                      type: 'object',
                      additionalProperties: false,
                      properties: {
                        id: { type: 'string' },
                        title: { type: 'string' },
                        description: { type: 'string' },
                        // extras do editor para auto-regra/preview
                        click_action: { enum: ['goto', 'set_mode', 'end'] },
                        goto_state: { type: 'string' },
                      },
                      required: ['id', 'title'],
                    },
                  },
                },
                required: ['rows'],
              },
            },
          },
          required: ['action', 'body', 'button_text', 'sections'],
        },

        /* -------- ask_var -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'ask_var' },
            var: { type: 'string' },
            prompt: { type: 'string' },
          },
          required: ['action', 'var', 'prompt'],
        },

        /* -------- validate_customer (NOVO) -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'validate_customer' },
          },
          required: ['action'],
        },

        /* -------- platform_lookup (ATUALIZADO) -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'platform_lookup' },
            op: { enum: ['status_pedido', 'link_transporte', 'nota_fiscal'] },
            messages: { type: 'object' }, // validado abaixo via if/then
          },
          required: ['action', 'op'],
          allOf: [
            // link_transporte / nota_fiscal: exige found / not_found (arrays de send_text)
            {
              if: { properties: { op: { enum: ['link_transporte', 'nota_fiscal'] } }, required: ['op'] },
              then: {
                properties: {
                  messages: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                      found: { $ref: '#/$defs/sendTextArray' },
                      not_found: { $ref: '#/$defs/sendTextArray' },
                    },
                    required: ['found', 'not_found'],
                  },
                },
                required: ['messages'],
              },
            },
            // status_pedido: 6 chaves suportadas (todas arrays de send_text)
            {
              if: { properties: { op: { const: 'status_pedido' } }, required: ['op'] },
              then: {
                properties: {
                  messages: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                      aguardando_pagamento: { $ref: '#/$defs/sendTextArray' },
                      aprovado: { $ref: '#/$defs/sendTextArray' },
                      cancelado: { $ref: '#/$defs/sendTextArray' },
                      analise_pagamento: { $ref: '#/$defs/sendTextArray' },
                      em_transporte: { $ref: '#/$defs/sendTextArray' },
                      entregue: { $ref: '#/$defs/sendTextArray' },
                    },
                    minProperties: 1,
                  },
                },
                required: ['messages'],
              },
            },
          ],
        },

        /* -------- goto -------- */
        {
          additionalProperties: false,
          properties: { action: { const: 'goto' }, state: { type: 'string' } },
          required: ['action', 'state'],
        },

        /* -------- set_mode -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'set_mode' },
            mode: { enum: ['bot', 'central'] },
            assign_agent_id: { type: ['string', 'number'] },
            assign_random_agent_ids: {
              type: 'array',
              minItems: 1,
              uniqueItems: true,
              items: { type: ['string', 'number'] },
            },
          },
          required: ['action', 'mode'],
        },

        /* -------- end -------- */
        {
          additionalProperties: false,
          properties: { action: { const: 'end' } },
          required: ['action'],
        },

        /* -------- set_tags -------- */
        {
          additionalProperties: false,
          properties: {
            action: { const: 'set_tags' },
            tags: {
              type: 'array',
              minItems: 1,
              uniqueItems: true,
              items: { type: ['string', 'number'] },
            },
          },
          required: ['action', 'tags'],
        },
      ],
    },
  },
}
